<ul class="nav nav-tabs mb-3">
  <li class="nav-item">
    <a href="#engine" data-toggle="tab" aria-expanded="false" class="nav-link">
      <span class="mdi mdi-home-variant d-md-none d-block"></span>
      <span class="d-none d-md-block">Engine</span>
    </a>
  </li>
  <li class="nav-item">
    <a href="#payments" data-toggle="tab" aria-expanded="true" class="nav-link active">
      <span class="mdi mdi-account-circle d-md-none d-block"></span>
      <span class="d-none d-md-block">Payments</span>
    </a>
  </li>
</ul>

<div class="tab-content">
  <div class="tab-pane" id="engine">

    <div class="m-3 text-dark">
      <form [formGroup]="origination">
        <div class="row d-flex">
          <div class="col-md-2 form-group">
            <label>Sale Date</label>
            <input type="date" id="saleDate" class="form-control" formControlName="saleDate"
              (blur)="calculate($event)">
          </div>
          <div class="col-md-1 form-group">
            <label>Sale Price</label>
            <input type="number" id="salePrice" class="form-control" formControlName="salePrice"
              (blur)="calculate($event)">
          </div>
          <div class="col-md-2 form-group">
            <label for="taxMethod">Tax Method</label>
            <select class="form-control form-control-sm" id="taxMethod" formControlName="taxMethod"
              (blur)="calculate($event)">
              @for (method of taxMethodKeys; track method) {
                <option [value]="method">{{taxMethods[method]}}
                </option>
              }
            </select>
          </div>
          <div class="col-md-2 form-group">
            <label for="financingType">Financing Type</label>
            <select class="form-control form-control-sm" id="financingType"
              formControlName="financingTypeId">
              <option value="Outside">Outside Financing</option>
              <option value="BHPH">BHPH</option>
            </select>
          </div>
          <div class="col-md-2 form-group">
            <label>Trade-in Allowance</label>
            <input type="number" id="tradeInAllowance" class="form-control"
              formControlName="tradeInAllowance" (blur)="calculate($event)">
          </div>
          <div class="col-md-3 form-group">
            <label>Total Down</label>
            <div class="input-group">
              <input type="number" id="totalDown" class="form-control" formControlName="totalDown"
                readonly (blur)="calculate($event)">
              <div class="input-group-append">
                <button type="button" class="btn btn-sm btn-outline-primary" data-toggle="modal"
                  data-target="#down-payment-modal" id="down-payment-btn">Manage Down
                Payments</button>
              </div>
            </div>
            @if (downPaymentSums) {
              <small>@if (downPaymentSums['initial'] > 0) {
                <span>Initial:
                {{downPaymentSums['initial']}} </span>
                }@if (downPaymentSums['deferred'] > 0) {
                <span
                  >Deferred:
                {{downPaymentSums['deferred']}}</span>
              }</small>
            }
          </div>
          <div class="col-md-2 form-group">
            <label>Model Year</label>
            <input type="number" id="modelYear" class="form-control" formControlName="modelYear"
              (blur)="calculate($event)">
          </div>
          <div class="col-md-2 form-group">
            <label>Tax Rate</label>
            <input type="number" id="taxRate" class="form-control" formControlName="taxRate"
              (blur)="calculate($event)">
          </div>
          <div class="col-md-2 form-group">
            <label>Subject To Finance</label>
            <input type="number" id="subjectToFinance" class="form-control"
              formControlName="subjectToFinance" (blur)="calculate($event)">
            @if (origination.get('taxMethod').value == 'DEFERRED' && scheduleTotals) {
              <small>With Tax:
              {{scheduleTotals.totalTax + origination.get('subjectToFinance').value}}</small>
            }
          </div>
          <div class="col-md-2 form-group">
            <label>Payment Cycle</label>
            <select id="paymentCycle" class="form-control" formControlName="paymentCycle"
              (blur)="calculate($event)">
              <option value="Monthly" selected>Monthly</option>
              <option value="Semimonthly">Semimonthly</option>
              <option value="Weekly">Weekly</option>
              <option value="Biweekly">Biweekly</option>
            </select>
          </div>
          <div class="col-md-2 form-group">
            <label>Number of Payments</label>
            <input type="number" id="numberOfPayments" class="form-control"
              formControlName="numberOfPayments" (blur)="calculate($event)">
          </div>
          <div class="col-md-2 form-group">
            <label>APR</label>
            <input type="number" id="apr" class="form-control" formControlName="apr"
              (blur)="calculate($event)">
          </div>
          <div class="col-md-3 form-group">
            <label>1st Scheduled Payment Due Date</label>
            <input type="date" id="firstScheduledPaymentDueDate" class="form-control"
              formControlName="firstScheduledPaymentDueDate" (blur)="calculate($event)">
          </div>
          <div class="col-md-2 form-group">
            <label>Payment Amount</label>
            <input type="number" id="scheduledPaymentAmount" class="form-control form-control-sm"
              formControlName="scheduledPaymentAmount" (blur)="calculate($event)">
          </div>
          <div class="col-md-2 form-group align-content-end">
            <div class="form-check mb-2">
              <input type="checkbox" id="excludeAmort" class="form-check-input"
                formControlName="excludeAmort" (blur)="calculate($event)">
              <label class="form-check-label" for="excludeAmort">Exclude Amortization</label>
            </div>
          </div>
        </div>
      </form>
      <!-- totals -->
      @if (scheduleTotals) {
        <div class="row p-0 m-0">
          <div class="col-md-6">
            <ul class="list-group">
              <li class="list-group-item border">totalPayments: {{scheduleTotals.totalPayments | currency}}
              </li>
              <li class="list-group-item border">totalPrincipalPaid: {{scheduleTotals.totalPrincipalPaid |
                currency}}
              </li>
              <li class="list-group-item border">financeCharges: {{scheduleTotals.financeCharges | currency}}
              </li>
              <li class="list-group-item border">totalTax: {{scheduleTotals.totalTax | currency}}
                totalDownPaymentTax:
                {{scheduleTotals.totalDownPaymentTax | currency}} totalPaymentTax:
                {{scheduleTotals.totalPaymentTax
              | currency}}</li>
              <li class="list-group-item border">difference: {{scheduleTotals.difference | currency}}</li>
              <li class="list-group-item border">apr: {{scheduleTotals.apr * 100}}</li>
              <li class="list-group-item border">contractRate: {{scheduleTotals.contractRate * 100}}</li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-group">
              <li class="list-group-item border">numberOfPayments: {{scheduleTotals.numberOfPayments}}
              </li>
              <li class="list-group-item border">scheduledPaymentAmount:
                {{scheduleTotals.scheduledPaymentAmount |
                currency}}
              </li>
              <li class="list-group-item border">finalOddLastPayment: {{scheduleTotals.finalOddLastPayment |
                currency}}
              </li>
              <li class="list-group-item border"
                [ngClass]="{'text-danger' : scheduleTotals.loanMaturityDate != scheduleTotals.calculatedMaturityDate}">
                loanMaturityDate: {{scheduleTotals.loanMaturityDate | date: "shortDate" }}
              calculatedMaturityDate: {{scheduleTotals.calculatedMaturityDate | date: "shortDate" }}</li>
              <li class="list-group-item border">maxLegalAPR: {{scheduleTotals.maxLegalAPR}}</li>
              <li class="list-group-item border">dealerAPRLimit: {{scheduleTotals.dealerAPRLimit}}</li>
              <li class="list-group-item border">solveFor: {{scheduleTotals.solveFor}}</li>
              <li class="list-group-item border">changedField: {{scheduleTotals.changedField}}</li>
            </ul>
          </div>
        </div>
      }
      <table class="table table-hover table-sm table-bordered text-dark">
        <thead>
          <tr>
            <th>Payment #</th>
            <th>Payment Type</th>
            <th>Due Date</th>
            <th>Scheduled Payment Amount</th>
            <!-- <th>Cumulative Payment Amount</th> -->
            <th>Principal Paid</th>
            <!-- <th>Cumulative Principal Paid</th> -->
            <th>Interest Amount</th>
            <th>Tax Amount</th>
            <th>Tax Amount (Down Payment)</th>
            <th>Tax Amount (Payment)</th>
            <th># of Days</th>
            <th>Current Balance</th>
          </tr>
        </thead>
        <tbody>
          @for (scheduleLine of schedule; track scheduleLine) {
            <tr>
              <td>{{scheduleLine.number}}</td>
              <td>{{scheduleLine.type}}</td>
              <td>{{scheduleLine.dueDate}}</td>
              <td>{{scheduleLine.scheduledPaymentAmount | currency}}</td>
              <!-- <td>{{scheduleLine.totalPayments | currency}}</td> -->
              <td>{{scheduleLine.principalPaid | currency}}</td>
              <!-- <td>{{scheduleLine.totalPrincipalPaid | currency}}</td> -->
              <td>{{scheduleLine.interestAmount | currency}}</td>
              <td>{{scheduleLine.taxAmount | currency}}</td>
              <td>{{scheduleLine.taxAmountForDownPayment | currency}}</td>
              <td>{{scheduleLine.taxAmountForPayment | currency}}</td>
              <td>{{scheduleLine.numberOfDays}}</td>
              <td>{{scheduleLine.currentBalance | currency}}</td>
            </tr>
          }
        </tbody>
        <tfoot id="paymentScheduleTotal"></tfoot>
      </table>
    </div>
    <div class="m-3 text-dark">
      @if (transactionBreakdown && transactionBreakdown.length > 0) {
        <h3>Transaction Breakdown</h3>
      }
      @if (transactionBreakdown && transactionBreakdown.length > 0) {
        <button type="button" class="btn btn-success btn-sm float-right" (click)="clearTransactionBreakdown()"
          id="addPmt">Clear Transaction
        Breakdown</button>
      }
      @if (transactionBreakdown && transactionBreakdown.length > 0) {
        <table class="table table-hover table-sm table-bordered text-dark"
          >
          <thead>
            <tr>
              <th>#</th>
              <th>Transaction #</th>
              <th>Payment #</th>
              <th>Principal Paid</th>
              <th>Interest Paid</th>
              <th>Tax Paid</th>
              <th>Days Late</th>
              <th>Late Fee</th>
            </tr>
          </thead>
          <tbody>
            @for (transactionBreak of transactionBreakdown; track transactionBreak) {
              <tr>
                <td>{{transactionBreak.number}}</td>
                <td>{{transactionBreak.transactionId}}</td>
                <td>{{transactionBreak.paymentId}}</td>
                <td>{{transactionBreak.principalPaid | currency}}</td>
                <td>{{transactionBreak.interestPaid | currency}}</td>
                <td>{{transactionBreak.taxPaid | currency}}</td>
                <td>{{transactionBreak.daysLate | number}}</td>
                <td>{{transactionBreak.lateFee | currency}}</td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td class="font-weight-bold">TOTALS</td>
              <td>{{sumOfPrincipalPaid | currency}}</td>
              <td>{{sumOfInterestPaid | currency}}</td>
              <td>{{sumOfTaxPaid | currency}}</td>
              <td></td>
              <td>{{sumOfLateFeesPaid | currency}}</td>
            </tr>
          </tfoot>
        </table>
      }

      <form [formGroup]="terms">
        <div class="row">
          <div class="col-md-2 form-group">
            <label>Total Tax Ratio</label>
            <input type="number" id="totalTax" class="form-control" formControlName="taxRatio">
            @if (terms.get('taxRatio').value && scheduleTotals) {
              <small>
              {{terms.get('taxRatio').value * 100 | number: '1.2-6'}}%</small>
            }
          </div>
          <div class="col-md-2 form-group">
            <label>Daily APR</label>
            <input type="number" id="totalTax" class="form-control" formControlName="dailyAPR">
            @if (terms.get('dailyAPR').value && scheduleTotals) {
              <small>
              {{terms.get('dailyAPR').value * 100 | number: '1.2-6'}}%</small>
            }
          </div>
          <div class="col-md-2 form-group">
            <label>Platform</label>
            <select class="form-control form-control-sm" id="platform" formControlName="platform">
              <option value="Desktop">Desktop</option>
              <option value="Web">Web</option>
              <option value="API">API</option>
            </select>
          </div>
          <div class="col-md-2 form-group">
            <div class="form-check mb-2">
              <input type="checkbox" id="chargeLateFees" class="form-check-input"
                formControlName="chargeLateFees">
              <label class="form-check-label" for="chargeLateFees">Charge Late Fees?</label>
            </div>
          </div>
        </div>
      </form>
      @if (transactionBreakdown && transactionBreakdown.length > 0) {
        <ul class="list-group list-group-horizontal"
          >
          <li class="list-group-item">Cumulative Amount Paid: {{sumOfAmountPaid | currency}}</li>
          <li class="list-group-item">Cumulative Principal Paid: {{sumOfPrincipalPaid | currency}}</li>
          <li class="list-group-item">Cumulative Interest Paid: {{sumOfInterestPaid | currency}}</li>
          <li class="list-group-item">Cumulative Tax Paid: {{sumOfTaxPaid | currency}}</li>
          <li class="list-group-item">Cumulative Tax Paid to Comptroller: {{sumOfTaxPaidToComptroller | currency}}
          </li>
          <li class="list-group-item">Cumulative Late Fees Paid: {{sumOfLateFeesPaid | currency}}</li>
          <li class="list-group-item">Remaining Unpaid Amount: {{sumOfAmountPaid -
          (scheduleTotals.totalPayments + origination.get('totalDown').value) | currency}}</li>
          <li class="list-group-item">Remaining Unpaid Principal: {{sumOfPrincipalPaid -
          scheduleTotals.totalPrincipalPaid - origination.get('totalDown').value | currency}}</li>
          <li class="list-group-item">Remaining Unpaid Interest: {{sumOfInterestPaid -
            scheduleTotals.financeCharges |
          currency}}</li>
          <li class="list-group-item">Remaining Of Unpaid Tax: {{sumOfTaxPaid - scheduleTotals.totalTax |
            currency}}
          </li>
          <li class="list-group-item">Principal %: {{sumOfPrincipalPaid / origination.get('salePrice').value |
            percent:'2.2-2' }}
          </li>
        </ul>
      }
      @if (transactions && transactions.controls.length > 0) {
        <h3>Transactions</h3>
      }
      @if (scheduleTotals) {
        <button type="button" class="btn btn-success btn-sm" (click)="addTransaction()" id="addPmt"
        >Add Transaction</button>
      }
      @if (transactions) {
        <button type="button" class="btn btn-success btn-sm float-right" (click)="clearTransactions()" id="addPmt"
        >Clear Transactions</button>
      }
      @if (transactions && transactions.controls.length > 0) {
        <form [formGroup]="paymentInformation">
          <table formArrayName="transactions">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Date Paid</th>
                <th>Amount Paid</th>
                <th>Principal Paid</th>
                <th>Interest Paid</th>
                <th>Tax Amount <small>(Includes Initial Down Payment Amount)</small></th>
                <th>Tax Paid <small>(To Comptroller)</small></th>
                <th>Late Fees</th>
                <th>Payoff After Payment</th>
                <th>Unpaid Principal Balance After Payment</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (pmtForm of transactions.controls; track pmtForm; let i = $index) {
                <tr [formGroup]="pmtForm">
                  <td>{{pmtForm.get('transactionId').value}}</td>
                  <td> <input class="form-control" type="text" id="datePaid-{{i}}" formControlName="datePaid"
                    type="date" (blur)="calcDue($event, i)">
                    <small id="amountDue-{{i}}"></small>
                  </td>
                  <td> <input class="form-control" type="text" id="amountPaid-{{i}}"
                  formControlName="amountPaid" type="number"></td>
                  <td> <input class="form-control" type="text" id="principalDue-{{i}}"
                  formControlName="principalDue" type="number" disabled></td>
                  <td> <input class="form-control" type="text" id="interestDue-{{i}}"
                  formControlName="interestDue" type="number" disabled></td>
                  <td> <input class="form-control" type="text" id="taxDue-{{i}}" formControlName="taxDue"
                  type="number" disabled></td>
                  <td> <input class="form-control" type="text" id="taxableToState-{{i}}"
                  formControlName="taxableToState" type="number" disabled></td>
                  <td> <input class="form-control" type="text" id="lateFeesDue-{{i}}"
                  formControlName="lateFeesDue" type="number" disabled></td>
                  <td> <input class="form-control" type="text" id="payoffAfterPayment-{{i}}"
                  formControlName="payoffAfterPayment" type="number" disabled></td>
                  <td> <input class="form-control" type="text" id="unpaidPrincipalBalanceAfterPayment-{{i}}"
                  formControlName="unpaidPrincipalBalanceAfterPayment" type="number" disabled></td>
                  <td> <button class="btn btn-sm" (click)="removeTransaction(i)"><span
                  class="dripicons-trash text-danger"></span></button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </form>
    }

    @if (scheduleTotals) {
      <button type="button" class="btn btn-success btn-sm float-right" (click)="setDemoTransaction()" id="addPmt"
      >Set Demo</button>
    }
    @if (transactions.length > 0) {
      <button type="button" class="btn btn-success btn-sm" (click)="chooseEngine()" id="calc"
      >Calculate</button>
    }
    @if (scheduledPayments.length > 0) {
      <button type="button" class="btn btn-success btn-sm float-right" (click)="buildPayments()" id="buildPmt"
      >Reset to Original Amortization</button>
    }

    @if (scheduledPayments.value.length > 0 && transactions.length > 0) {
      <h3>Updated Amortization</h3>
    }
    @if (scheduledPayments.value.length > 0 && transactions.length > 0) {
      <table class="table table-hover table-sm table-bordered text-dark"
        >
        <thead>
          <tr>
            <th>Payment #</th>
            <th>Payment Type</th>
            <th>Due Date</th>
            <th>Status</th>
            <th>Scheduled Payment Amount</th>
            <th>Amount Due</th>
            <th>Principal Due</th>
            <th>Interest Amount Due</th>
            <th>Total Tax Amount Due</th>
            <th>Tax Amount (Payment) Due</th>
            <th>Tax Amount (Down Payment) Due</th>
            <th>Days Late</th>
          </tr>
        </thead>
        <tbody>
          @for (scheduledPmt of scheduledPayments.value; track scheduledPmt) {
            <tr>
              <td>{{scheduledPmt.number}}</td>
              <td>{{scheduledPmt.type}}</td>
              <td>{{scheduledPmt.dueDate}}</td>
              <td>{{scheduledPmt.status}}</td>
              <td>{{scheduledPmt.scheduledPaymentAmount | currency}}</td>
              <td>{{scheduledPmt.amountDue | currency }}</td>
              <td>{{scheduledPmt.principalPaid | currency}}</td>
              <td>{{scheduledPmt.interestAmount | currency}}</td>
              <td>{{scheduledPmt.taxAmount | currency}}</td>
              <td>{{scheduledPmt.taxAmountForPayment | currency}}</td>
              <td>{{scheduledPmt.taxAmountForDPayment | currency}}</td>
              <td>{{scheduledPmt.daysLate | number}}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
<div class="tab-pane show active" id="payments">
  <form [formGroup]="paymentParameters">
    <div class="row d-flex">
      <div class="col-md-2 form-group">
        <label>Dealer ID</label>
        <input type="number" id="dealer" class="form-control" formControlName="dealer">
      </div>
      <div class="col-md-2 form-group">
        <label>Lot ID</label>
        <input type="number" id="lot" class="form-control" formControlName="lot">
      </div>
      <div class="col-md-2 form-group">
        <label>Term ID</label>
        <input type="number" id="term" class="form-control" formControlName="term">
      </div>
      <div class="col-md-2 form-group">
        <label>Contact ID</label>
        <input type="number" id="contact" class="form-control" formControlName="contact">
      </div>
    </div>
  </form>
  <!-- <table class="table table-hover table-sm table-bordered text-dark"
  *ngIf="updatedPaymentSchedule && updatedPaymentSchedule.length > 0">
  <thead>
    <tr>
      <th>#</th>
      <th>Transaction #</th>
      <th>Status</th>
      <th>Due Date</th>
      <th>Amount Due</th>
      <th>Category</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let updatePS of updatedPaymentSchedule">
      <td>{{updatePS.number}}</td>
      <td>{{updatePS.id}}</td>
      <td>{{updatePS.status}}</td>
      <td>{{updatePS.due | date: "shortDate"}}</td>
      <td>{{updatePS.amount | currency}}</td>
      <td>{{updatePS.category }}</td>
    </tr>
  </tbody>
</table> -->
<button class="btn btn-sm btn-primary" (click)="getPayments()">Get Payments</button>
@if (transactionBreakdown2 && transactionBreakdown2.length > 0) {
  <table class="table table-hover table-sm table-bordered text-dark"
    >
    <thead>
      <tr>
        <!-- <th>#</th>
        <th>Transaction #</th> -->
        <th>Payment #</th>
        <th>Status</th>
        <th>Due Date</th>
        <th>Paid Date</th>
        <th>Due Days</th>
        <th>Late Fee Due</th>
        <th>Late Fee Paid</th>
        <th>Late Fee Unpaid</th>
        <th>Amount Due</th>
        <th>Amount Paid</th>
        <th>Total Amount Due</th>
        <th>Total Amount Paid</th>
        <th>Category</th>
        <th>Receipt ID</th>
        <th>Payment Method</th>
      </tr>
    </thead>
    <tbody>
      @for (transactionBreak of transactionBreakdown2; track transactionBreak) {
        <tr>
          <!-- <td>{{transactionBreak.number}}</td>
          <td>{{transactionBreak.id}}</td> -->
          <td>{{transactionBreak.number}}</td>
          <td>{{transactionBreak.status}}</td>
          <td>{{transactionBreak.dueDate | date: "shortDate"}}</td>
          <td>{{transactionBreak.datePaid | date: "shortDate"}}</td>
          <td></td>
          <td>{{transactionBreak.lateFeeDue | currency}}</td>
          <td>{{transactionBreak.lateFeePaid | currency}}</td>
          <td>{{transactionBreak.lateFeeUnpaid | currency}}</td>
          <td>{{transactionBreak.amountDue | currency}}</td>
          <td>{{transactionBreak.amountPaid | currency}}</td>
          <td>{{transactionBreak.totalAmountDue | currency}}</td>
          <td>{{transactionBreak.totalAmountPaid | currency}}</td>
          <td>{{transactionBreak.category }}</td>
          <td>{{transactionBreak.receiptId}}</td>
          <td>{{transactionBreak.paymentMethod}}</td>
        </tr>
      }
    </tbody>
  </table>
}
@if (lines && lines.length > 0) {
  <table class="table table-hover table-sm table-bordered text-dark"
    >
    <thead>
      <tr>
        <!-- <th>#</th>
        <th>Transaction #</th> -->
        <th>Payment #</th>
        <th>Status</th>
        <th>Due Date</th>
        <th>Paid Date</th>
        <th>Due Days</th>
        <th>Late Fee Due</th>
        <th>Loan Amount Due</th>
        <th>Total Amount Due</th>
        <th>Late Fee Paid</th>
        <th>Loan Amount Paid</th>
        <th>Total Amount Paid</th>
        <th>Loan Unpaid</th>
        <th>Late Fee Unpaid</th>
        <th>Category</th>
        <th>Receipt ID</th>
        <th>Payment Method</th>
      </tr>
    </thead>
    <tbody>
      @for (transactionBreak of lines; track transactionBreak) {
        <tr>
          <!-- <td>{{transactionBreak.number}}</td>
          <td>{{transactionBreak.id}}</td> -->
          <td>{{transactionBreak.number}}</td>
          <td>{{transactionBreak.status}}</td>
          <td>{{transactionBreak.dueDate | date: "shortDate"}}</td>
          <td>{{transactionBreak.datePaid | date: "shortDate"}}</td>
          <td>{{transactionBreak.daysLate}}</td>
          <td>{{transactionBreak.lateFeeDue | currency}}</td>
          <td>{{transactionBreak.amountDue | currency}}</td>
          <td>{{transactionBreak.totalAmountDue | currency}}</td>
          <td>{{transactionBreak.lateFeePaid | currency}}</td>
          <td>{{transactionBreak.amountPaid | currency}}</td>
          <td>{{transactionBreak.totalAmountPaid | currency}}</td>
          <td>{{transactionBreak.amountUnpaid | currency}}</td>
          <td>{{transactionBreak.lateFeeUnpaid | currency}}</td>
          <td>{{transactionBreak.category }}</td>
          <td>{{transactionBreak.receiptNumber}}</td>
          <td>{{transactionBreak.paymentMethod}}</td>
        </tr>
      }
    </tbody>
  </table>
}
</div>
</div>


<!-- modals -->
<div class="modal fade" id="down-payment-modal" tabindex="-1" data-backdrop="static" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">Setup Down Payments</h4>
        <button type="button" class="close" data-dismiss="modal"
        id="close-modal-identifications">×</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="downPayment">
          <ng-container formArrayName="downPayments">
            <button class="btn btn-sm btn-outline-primary" (click)="addDownPayment()">Add Down
            Payment</button>
            @for (dPmt of downPayments.controls; track dPmt; let i = $index) {
              <div>
                <div class="row" [formGroup]="dPmt">
                  <div class="col-md-3 form-group">
                    <label for="scheduledPaymentAmount">Amount Due</label>
                    <input type="number" id="scheduledPaymentAmount" class="form-control"
                      formControlName="scheduledPaymentAmount" />
                  </div>
                  <div class="col-md-3 form-group">
                    <label for="dueDate">Due Date</label>
                    <input type="date" id="dueDate" class="form-control" formControlName="dueDate" />
                  </div>
                  <div class="col-md-3 form-group">
                    <div class="form-check mb-2">
                      <input type="checkbox" id="initial" class="form-check-input"
                        formControlName="initial" />
                      <label class="form-check-label" for="initial">Initial Down?</label>
                    </div>
                  </div>
                  <div class="col-md-3 form-group">
                    <button class="btn btn-sm" (click)="removeDownPayment(i)"><span
                    class="dripicons-trash text-danger"></span></button>
                  </div>
                </div>
              </div>
            }
          </ng-container>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-light" id="btn-cancel" data-dismiss="modal" (click)="sumDownPayments()">{{
          words[language][ 'close'
        ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->